import { omitBy } from "es-toolkit";
import type { CSSProperties } from "react";

export const stripUndefined = (config: Record<string, unknown>) =>
  omitBy(config, (value) => value === undefined || value === "") as Record<string, unknown>;

export const stripDefaultValues = (newCssProperties: CSSProperties, configCssProperties: CSSProperties) =>
  omitBy(
    newCssProperties,
    (value, key) => key in configCssProperties && value === configCssProperties[key as keyof CSSProperties],
  );

export const provideDefaultValues = <T extends CSSProperties>(
  cssProperties: Partial<CSSProperties>,
  defaults: T,
): T => ({
  ...defaults,
  ...stripUndefined(cssProperties ?? {}),
});
